import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AppointmentTable from "../components/AppointmentTable";

import { Icon } from "@iconify/react/dist/iconify.js";
import { API_URL, LOCATION_ID, TOKEN } from "..";
import { Link, useParams } from "react-router-dom";
import ViewStaffLayer from "./ViewStaffLayer";

const ViewStaffPage = () => {
    const { id } = useParams();
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchStaffFromGHL = async () => {
        setLoading(true);
        setError(null);
        try {
            const options = {
                method: 'GET',
                url: `https://services.leadconnectorhq.com/users/${id}`,
                params: { locationId: localStorage.getItem('locationID') },
                headers: {
                    Authorization: `Bearer ${TOKEN}`,
                    Version: '2021-07-28',
                    Accept: 'application/json'
                }
            };

            // Using axios for consistency with other components, but you can use fetch if preferred
            const response = await fetch(options.url + `?locationId=${LOCATION_ID}`, {
                method: options.method,
                headers: options.headers
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const responseData = await response.json();
            const user = responseData.user || responseData;

            let localUser = null;
            try {
                const localRes = await fetch(`${API_URL}/api/user/fetch-single/${id}`);
                const localJson = await localRes.json();
                if (localJson && localJson.data) {
                    localUser = localJson.data;
                }
            } catch (e) {
                console.warn("Could not fetch local user:", e.message);
            }

            if (user) {
                // Map GoHighLevel user data to the format expected by ViewStaffLayer
                const mappedData = {
                    id: user.id || localUser?.crm_id || localUser?.id || id,
                    name: `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.name || localUser?.name || 'N/A',
                    email: (localUser?.email && localUser.email.toLowerCase().includes('coppergat')) ? localUser.email : (user.email || localUser?.email || 'N/A'),
                    phone: localUser?.phone || user.phone || 'N/A',
                    role: user.role || user.roles?.[0] || localUser?.role || 'user',
                    status: user.isActive ? 'active' : (localUser?.status || 'inactive'),
                    cityId: localUser?.cityId || localUser?.city?.id || null,
                    city: localUser?.city || null,
                    cityName: localUser?.city?.name || 'N/A',
                    createdAt: user.dateAdded || user.createdAt || localUser?.createdAt || new Date().toISOString(),
                    updatedAt: user.dateUpdated || user.updatedAt || localUser?.updatedAt || new Date().toISOString()
                };
                setData(mappedData);
            } else {
                throw new Error('User not found');
            }
        } catch (err) {
            console.error('Error fetching staff from GoHighLevel:', err);
            // Fallback to local user
            try {
                const localRes = await fetch(`${API_URL}/api/user/fetch-single/${id}`);
                const localJson = await localRes.json();
                if (localJson && localJson.data) {
                    const localUser = localJson.data;
                    setData({
                        id: localUser.crm_id || localUser.id || id,
                        name: localUser.name || 'N/A',
                        email: localUser.email || 'N/A',
                        phone: localUser.phone || 'N/A',
                        role: localUser.role || 'user',
                        status: localUser.status || 'active',
                        cityId: localUser.cityId || localUser.city?.id || null,
                        city: localUser.city || null,
                        cityName: localUser.city?.name || 'N/A',
                        createdAt: localUser.createdAt || new Date().toISOString(),
                        updatedAt: localUser.updatedAt || new Date().toISOString()
                    });
                    setLoading(false);
                    return;
                }
            } catch (e) {}
            setError(err.message || 'Failed to fetch staff information');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStaffFromGHL();
    }, [id]); // Use [id] instead of [1] for proper dependency

    if (loading) {
        return (
            <MasterLayout>
                <div className="container py-5">
                    <div className="text-center">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-2">Loading staff details...</p>
                    </div>
                </div>
            </MasterLayout>
        );
    }

    if (error) {
        return (
            <MasterLayout>
                <Breadcrumb title="View Staff" />
                <div className="container py-5">
                    <div className="alert alert-danger" role="alert">
                        {error}
                        <div className="mt-3">
                            <Link to="/staff" className="btn btn-primary">Back to Staff List</Link>
                        </div>
                    </div>
                </div>
            </MasterLayout>
        );
    }

    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title="View Staff" />
                <div className="mt-4 mb-20">
                    <div className="col-xxl-12">
                        {/* TableDataLayer */}
                        <ViewStaffLayer data={data} />
                    </div>
                </div>
            </MasterLayout>
        </>
    );
};

export default ViewStaffPage;